import { useEffect } from "react";
import { Outlet } from "react-router-dom";


export default function NewUserPage() {

  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  return(<div className="container mx-auto px-4">
          <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../Assets/slogan-white.png')}/>
      </div>
    <Outlet/>
  </div>)
}